export enum ErrorTypes {
  CreditErrors = "CREDIT_ERRORS",
  InvoiceErrors = "INVOICE_ERRORS",
  PaymentErrors = "PAYMENT_ERRORS",
  SchedulePaymentErrors = "SCHEDULE_PAYMENT_ERRORS"
}

const CREDIT_ERRORS = {
  INVALID_REQUEST_PARAMETERS:
    "Something went wrong. Please try refreshing the page or come back later.",
  SERVICE_UNAVAILABLE:
    "Something went wrong. Please try refreshing the page or come back later.",
  INVALID_CREDENTIALS: "Sorry, You're not authorized to access this resource.",
  DEFAULT:
    "We’re unable to retrieve your credits at the moment. Please try again later."
} as const;

const INVOICE_ERRORS = {
  INVALID_REQUEST_PARAMETERS:
    "Something went wrong. Please try refreshing the page or come back later.",
  SERVICE_UNAVAILABLE:
    "Something went wrong. Please try refreshing the page or come back later.",
  INVALID_CREDENTIALS: "Sorry, You're not authorized to access this resource.",
  DEFAULT:
    "We’re unable to retrieve your invoices at the moment. Please try again later."
} as const;

const PAYMENT_ERRORS = {
  INVALID_REQUEST_PARAMETERS:
    "Something went wrong. Please try refreshing the page or come back later.",
  SERVICE_UNAVAILABLE:
    "Something went wrong. Please try refreshing the page or come back later.",
  INVALID_CREDENTIALS: "Sorry, You're not authorized to access this resource.",
  DEFAULT:
    "We’re unable to retrieve your invoices at the moment. Please try again later."
} as const;

const SCHEDULE_PAYMENT_ERRORS = {
  INVALID_REQUEST_PARAMETERS:
    "Something went wrong. Please try refreshing the page or come back later.",
  SERVICE_UNAVAILABLE:
    "Something went wrong. Please try refreshing the page or come back later.",
  INVALID_CREDENTIALS: "Sorry, You're not authorized to access this resource.",
  DEFAULT:
    "We’re unable to retrieve your payment schedule at the moment. Please try again later."
} as const;

export const errorMessages = {
  [ErrorTypes.CreditErrors]: CREDIT_ERRORS,
  [ErrorTypes.InvoiceErrors]: INVOICE_ERRORS,
  [ErrorTypes.PaymentErrors]: PAYMENT_ERRORS,
  [ErrorTypes.SchedulePaymentErrors]: SCHEDULE_PAYMENT_ERRORS
};

export type ApiErrorKey = keyof typeof errorMessages;
